'use strict';

// Detalhe meu Chamado Controller

var detalheChamadoMdl = angular.module('detalheChamadoMdl');
detalheChamadoMdl.controller('detalheChamadoCtrl', detalheChamadoCtrl);

detalheChamadoCtrl.$inject = [
    '$scope',
    '$filter',
    '$stateParams',
    'notificacao',
    'detalheChamadoApi',
    'chamadosApi',
    'categorizacoesApi',
    'Event'
];

function detalheChamadoCtrl(
    $scope,
    $filter,
    $stateParams,
    notificacao,
    detalheChamadoApi,
    chamadosApi,
    categorizacoesApi,
    Event) {

    var $ctrl = this;

    $ctrl.buscarRedirecionamento = buscarRedirecionamento;
    $ctrl.atualizarChamado = atualizarChamado;
    $ctrl.carregar = carregar;
    $ctrl.redirecionamentos = [];
    $ctrl.dimensaoArquivos = 0;

    carregar();

    Event.on('chamado:atualizar', function(event, payload){
        if( payload.chamadoId && payload.chamadoId == $ctrl.infoChamado.chamadoId ){
            $ctrl.atualizarChamado();
        }
    })($scope)

    function carregar()
    {
        $ctrl.chamado = chamadosApi.detalhesChamado({
                        chamadoId: $stateParams.chamadoId
        }, function (infoChamado) {

            _.map(infoChamado.anexos, function (anexo) {
                anexo.ehImagem = /.png|png|.jpg|jpg|jpeg|.jpeg|.gif|gif/g.test(anexo.arquivoExtensao);
            });

            $ctrl.dimensaoArquivos = _.sumBy(
                infoChamado.anexos, 'arquivoTamanhoEmBytes'
            );

            $ctrl.infoChamado = infoChamado;

            $ctrl.buscarRedirecionamento(infoChamado)

            return infoChamado;

        }, function (erros) {
            notificacao.erroResponse(erros);
        }).$promise;

    }

    function atualizarChamado()
    {
        $ctrl.carregar();
    }

    function buscarRedirecionamento(chamado)
    {
        detalheChamadoApi.redirecionamentos({
            chamadoId: chamado.chamadoId
        }, function(redirecionamento){
            $ctrl.redirecionamentos = redirecionamento;
        }, function(){
            $ctrl.redirecionamentos = [];
        })
    }
 
    /**
     * Ouvinte para o evento colar no formulario
     * de abertura de chamado
     * 
     * @param object $event
     */
    function colar($event) 
    {

        Event.fire('anexo.colar-arquivo', $event);

    }

}


// WEBPACK FOOTER //
// ./src/modules/detalhe-chamado/detalhe-chamado-controller.js